import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

import { I18nModule, provideConfig } from '@spartacus/core';
import { FacetService, MediaModule, ProductFacetService } from '@spartacus/storefront';

import { DpActiveFacetsComponent } from './active-facets';
import { DpFacetCategoryListComponent } from './facet-category-list';
import { DpProductFacetNavigationComponent } from './product-facet-navigation.component';
import { DpFacetService, DpProductFacetService } from './services';

@NgModule({
  imports: [
    CommonModule,
    DpActiveFacetsComponent,
    I18nModule,
    DpFacetCategoryListComponent,
    MatIcon,
    RouterLink,
    MediaModule
  ],
  providers: [
    {
      provide: ProductFacetService,
      useClass: DpProductFacetService
    },
    {
      provide: DpProductFacetService,
      useExisting: ProductFacetService
    },
    {
      provide: FacetService,
      useClass: DpFacetService
    },
    provideConfig({
      cmsComponents: {
        ProductRefinementComponent: {
          component: DpProductFacetNavigationComponent
        }
      }
    })
  ],
  declarations: [DpProductFacetNavigationComponent],
  exports: [DpProductFacetNavigationComponent]
})
export class DpProductFacetNavigationModule {}
